// Point d'entrée de « Dans le Bureau ».
//
// Ordre volontaire, et il compte :
//   1. le code historique se charge et déclare ses fonctions,
//   2. celles que les attributs HTML appellent sont posées sur window,
//   3. seulement ensuite on ouvre la connexion.
// L'inverse ferait démarrer l'app avant que ses gestionnaires existent — un clic
// rapide sur un onglet tomberait dans le vide.

import { globalesHtml, showApp } from "./legacy.js";
import { demarrerGate } from "./lib/etikid.js";
import { prendreLien } from "./lib/lien.js";
import { monterNavigation } from "./features/navigation.js";
import { monterPressePapier } from "./features/presse-papier-ui.js";
import { monterBoutonVersion } from "./features/version-bouton.js";

// 1. Réexposition des fonctions citées dans les attributs HTML inline.
//    Elle vient AVANT le montage de la navigation : les boutons appellent
//    `window.setTab` au clic, et un clic rapide tomberait sinon dans le vide.
Object.assign(window, globalesHtml);

// 2. Navigation à deux étages, construite depuis la TABLE et non écrite en dur.
//    C'est ce qui garantit qu'un onglet déclaré a forcément son bouton, et qu'un
//    bouton pointe forcément vers un onglet qui existe.
monterNavigation();

// Chip de version dans l'en-tête : affiche la version, ouvre le changelog, et
// sert de roue de secours si la détection automatique échoue (cache agressif,
// PWA iOS qui ressert sa coquille).
monterBoutonVersion(document.querySelector("header.top"));

// Presse-papier : monté AVANT la connexion, parce qu'il restaure son contenu
// depuis le stockage local. Une réponse gardée hier doit être encore là ce matin,
// même si la session EtikID, elle, a expiré.
monterPressePapier();

// 3. Lien direct (?onglet=…&labo=…) : gardé AVANT le gate, qui peut partir vers EtikID aussitôt et
//    dont le retour efface l'adresse. showApp l'applique — voir lib/lien.js.
prendreLien();

// 4. Connexion, puis montage de l'app.
demarrerGate(showApp);
